import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFB] flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#0097A7] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-sm text-[#4E6974]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    const returnUrl = location.pathname + location.search;
    return <Navigate to={`/signin?return=${encodeURIComponent(returnUrl)}`} replace />;
  }

  // Force password change
  if (user.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  // Admin-only routes
  if (adminOnly && !user.is_platform_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Onboarding redirect (skip for admin routes, change-password, billing, and onboarding itself)
  if (
    !user.onboarding_completed &&
    !user.is_platform_admin &&
    !location.pathname.startsWith('/onboarding') &&
    !location.pathname.startsWith('/billing') &&
    location.pathname !== '/change-password'
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
